module.exports = __webpack_public_path__ + "img/whatsapp.24b577fb.svg";